<template class="form-dados-cadastrais">
  <div class="telaProposições">
    <v-form
      ref="formPreposicoes"
      v-model="proposicoesComerciais"
      @submit.prevent
    >
      <v-container class="pt-0">
        <div class="header-step">
          <h3>Proposições Comerciais</h3>
          <p>
            Informe as condições e considerações para a realização da proposta
            comercial.
          </p>
        </div>
        <div>
          <p><b>Proposições comerciais do(s) seguro(s):</b></p>
        </div>
        <v-layout row wrap>
          <v-flex xs12 md6>
            <v-select
              :disabled="disablePreposicaoComercial"
              v-model="dadosProposicoesComerciais.ramo"
              :items="ramoTransportador ? listaRamosTransportador : listaRamosEmbarcador"
              label="Ramo"
              item-text="titulo"
              item-value="titulo"
              :rules="regras.notNull"
              required
            >
            </v-select>
          </v-flex>
          <v-flex xs12 md6>
            <v-menu
              ref="menu"
              v-model="menu2"
              :close-on-content-click="false"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              offset-y
              full-width
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  :disabled="disablePreposicaoComercial"
                  v-model="textEdit"
                  label="Data de início da vigência"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                  required
                  :rules="regras.notNull"
                ></v-text-field>
              </template>
              <v-date-picker
                :disabled="disablePreposicaoComercial"
                v-model="dadosProposicoesComerciais.dataInicio"
                no-title
                scrollable
                :rules="regras.notNull"
                locale="pt-br"
              >
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex>
            <div>
              <p>
                <b
                  >Informe o valor da taxa ou do desconto desejado no Novo
                  Seguro de {{ dadosProposicoesComerciais.ramo }}:</b
                >
              </p>
            </div>
            <v-layout>
              <v-flex xs12 md3>
                <v-radio-group
                  :disabled="disablePreposicaoComercial"
                  required
                  ref="taxaDescontoAnteriorRadioRef"
                  row
                  v-model="dadosProposicoesComerciais.taxaOuDesconto"
                  :rules="regras.taxaDescontoAnteriorRadio"
                >
                  <v-radio
                    color="primary"
                    ref="naoPossuiSeguro"
                    id="chkTaxaSegurosAnteriores"
                    label="Taxa"
                    value="taxa"
                    checked
                  ></v-radio>
                  <v-radio
                    color="primary"
                    ref="naoPossuiSeguro"
                    id="chkDescontoSegurosAnteriores"
                    label="Desconto"
                    value="desconto"
                  ></v-radio>
                </v-radio-group>
              </v-flex>
              <v-flex
                v-if="dadosProposicoesComerciais.taxaOuDesconto != null"
                xs12
                md3
              >
                <v-text-field
                  v-show="dadosProposicoesComerciais.taxaOuDesconto == 'taxa'"
                  :disabled="disablePreposicaoComercial"
                  label="Taxa"
                  required
                  type="number"
                  @keypress="limitaCasasDecimaisTaxa"
                  v-model="dadosProposicoesComerciais.taxa"
                ></v-text-field>
                <v-text-field
                  v-show="
                    dadosProposicoesComerciais.taxaOuDesconto == 'desconto'
                  "
                  :disabled="disablePreposicaoComercial"
                  label="Desconto"
                  required
                  type="number"
                  @keypress="limitaCasasDecimaisDesconto"
                  v-model="dadosProposicoesComerciais.desconto"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex v-if="dadosProposicoesComerciais.ramo === 'RCTR-C e RCF-DC'">
            <div>
              <p>
                <b>Informe o valor da taxa no Novo Seguro de Roubo (RCF-DC):</b>
              </p>
            </div>
            <v-flex xs12 md6>
              <v-text-field
                :disabled="disablePreposicaoComercial"
                label="Informar a taxa"
                required
                type="number"
                v-model="dadosProposicoesComerciais.descontoNovoSeguro"
                :rules="regras.notNull"
              ></v-text-field>
            </v-flex>
          </v-flex>
          <v-spacer></v-spacer>
          <v-flex xs12 md10 class="textblack">
            Considerações
            <v-flex xs12 sm5 md12>
              <v-textarea
                v-model="dadosProposicoesComerciais.consideracao"
                class="textarea"
                height="150"
                outline
                :readonly="desabilitaConsideracao"
                :rules="[regras.length(2000)]"
                counter="2000"
              ></v-textarea>
            </v-flex>
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs4 md3>
            <v-btn
              flat
              color="primary"
              @click="$emit('voltarProposicoesComerciais', true)"
            >
              Voltar
            </v-btn>
          </v-flex>
          <v-flex xs4 md3>
            <v-btn
              :disabled="
                !valorTaxaOuDesconto ||
                  !dadosProposicoesComerciais.taxaOuDesconto ||
                  !dadosProposicoesComerciais.consideracao ||
                  !proposicoesComerciais
              "
              type="submit"
              color="primary"
              :loading="elementoPai.loadingEnvio"
              @click.native="enviar()"
            >
              enviar
            </v-btn>
          </v-flex>
          <v-flex xs4 md3> </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </div>
</template>

<script>
import axios from "axios";
import usuarioHelper from "@/helpers/usuario-logado";
import TipoCliente from '@/helpers/tipo-cliente'

export default {
  name: "QARProposicoesComerciais",
  props: {
    protocolo: String,
    dadosQuestionarioCompleto: {
      type: Object,
      require: false
    },
    dadosCadastrais: {
      type: Object, 
      required: false,
    }
  },
  data: () => ({
    proposicoesComerciais: true,
    descontoNovoSeguro: null,
    menu2: null,
    descontoAnterior: null,
    ramoTransportador: false,
    dadosProposicoesComerciais: {
      dataInicio: null,
      consideracao: null,
      ramo: null,
      container: false,
      taxa: null,
      desconto: null,
      vencimento: null,
      descontoApoliceAnterior: null,
      taxaOuDesconto: false,
      taxaApoliceAnterior: null,
      ocorreuSinistro: false,
      corretora: null,
      seguradora: null,
      coberturaRoubo: false
    },
    taxaOuDescontoRoubo: false,
    dateInicio: null,
    listaRamosTransportador: [
      { titulo: "RCTR-C", id: 1 },
      { titulo: "RCTR-C e RCF-DC", id: 2 }
    ],
    listaRamosEmbarcador: [
      { titulo: "Transporte Nacional", id: 3 },
      { titulo: "Exportação", id: 4 },
      { titulo: "Importação", id: 5 }
    ],
    regras: {
      notNull: [v => !!v || "Você não pode deixar este campo em branco"],
      length: len => v =>
        (v || "").length <= len ||
        `Número máximo de caractéres ultrapassado, requer no máximo ${len} caractéres.`,
      apoliceAnteriores: [
        v => !!v || "Você não pode deixar este campo em branco"
      ],
      seguradora: [v => !!v || "Você não pode deixar este campo em branco"],
      corretora: [
        v =>
          !v ||
          (!!v && (v.length == 0 || v.length <= 255)) ||
          "O campo deve ter no máximo 255 caracteres"
      ],
      taxaDescontoAnteriorRadio: [
        v => !!v || "Você não pode deixar este campo em branco"
      ],
      ocorreuSinistro: [
        v => !!v || "Você não pode deixar este campo em branco"
      ],
      porcentagemTaxa: [
        v =>
          CustomFormat.removePercentFormat(v) >= 0 ||
          "Você precisa informar um valor válido",
        v =>
          CustomFormat.removePercentFormat(v) <= 100 ||
          "Você precisa informar um valor válido",
        v =>
          (/^(100)$/g.test(v) && v.length < 8) ||
          (/^(100\,\d{1,3})$/g.test(v) && v.length < 8) ||
          (/^(\d{2})$/g.test(v) && v.length < 7) ||
          (/^(\d{2}\,\d{1,3})$/g.test(v) && v.length < 7) ||
          (/^(\d{1})$/g.test(v) && v.length < 6) ||
          (/^(\d{1}\,\d{1,3})$/g.test(v) && v.length < 6) ||
          "Você precisa informar um valor válido"
      ],
      porcentagemDesconto: [
        v =>
          CustomFormat.removePercentFormat(v) >= 0 ||
          "Você precisa informar um valor válido",
        v =>
          CustomFormat.removePercentFormat(v) <= 100 ||
          "Você precisa informar um valor válido",
        v =>
          (/^(100)$/g.test(v) && v.length < 8) ||
          (/^(100\,\d{1,2})$/g.test(v) && v.length < 8) ||
          (/^(\d{2})$/g.test(v) && v.length < 6) ||
          (/^(\d{2}\,\d{1,2})$/g.test(v) && v.length < 6) ||
          (/^(\d{1})$/g.test(v) && v.length < 5) ||
          (/^(\d{1}\,\d{1,2})$/g.test(v) && v.length < 5) ||
          "Você precisa informar um valor válido"
      ],
      valorPrejuizo: [
        v =>
          CustomFormat.removeMoneyFormat(v) > 0 ||
          "Você precisa informar um valor válido"
      ],

      descontoApoliceAnterior: [
        v =>
          (CustomFormat.removePercentFormat(v) >= 0 &&
            CustomFormat.removePercentFormat(v) <= 100) ||
          "Você precisa informar um desconto válido"
      ],
      taxaApoliceAnterior: [
        v =>
          (CustomFormat.removePercentFormat(v) > 0 &&
            CustomFormat.removePercentFormat(v) <= 100) ||
          "Você precisa informar uma taxa válida"
      ],
      coberturaRoubo: [v => !!v || "Você não pode deixar este campo em branco"],
      taxaRouboApoliceAnterior: [
        v =>
          (CustomFormat.removePercentFormat(v) > 0 &&
            CustomFormat.removePercentFormat(v) <= 100) ||
          "Você precisa informar uma taxa válida"
      ]
    }
  }),
  watch: {
    dadosQuestionarioCompleto(val) {
      if (val.id != null && val.id != undefined) {
        this.buscarTransportadora(val.idTransportadora);
        this.dadosProposicoesComerciais.ramo = val.novoSeguro.tipoSeguro;
        this.dadosProposicoesComerciais.dataInicio =
          val.novoSeguro.dataInicioVigencia;
        this.dadosProposicoesComerciais.desconto =
          val.novoSeguro.descontoDesejado;
        this.dadosProposicoesComerciais.taxaOuDesconto =
          val.novoSeguro.taxaDesejada != null ? "taxa" : "desconto";
        this.dadosProposicoesComerciais.taxa = val.novoSeguro.taxaDesejada;
        this.dadosProposicoesComerciais.descontoNovoSeguro =
          val.novoSeguro.taxaCoberturaRoubo;
          this.dadosProposicoesComerciais.consideracao = val.novoSeguro.expectativa;
      }
    },
    dadosCadastrais(val) {
      if(val.transportadora.tipoCliente.id != null && val.transportadora.tipoCliente.id != undefined) {
        if (val.transportadora.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
            this.ramoTransportador = true;
        }
      }
    },
    "dadosProposicoesComerciais.taxaOuDesconto"() {
      if (this.dadosProposicoesComerciais.taxaOuDesconto) {
        if (this.dadosProposicoesComerciais.taxaOuDesconto == "taxa")
          this.dadosProposicoesComerciais.desconto = null;
        else if (this.dadosProposicoesComerciais.coberturaRoubo == "desconto")
          this.dadosProposicoesComerciais.taxa = null;
      }
    },
    "dadosProposicoesComerciais.container"() {
      if (this.dadosProposicoesComerciais.container == false) {
        return this.limparCampos();
      }
    },

    somaTotaisRotas: {
      handler: function() {
        if (this.somaTotaisRotas == 100) {
          this.valorCorretoRota = true;
        }
        if (isNaN(this.somaTotaisRotas)) {
          this.somaTotaisRotas = 0;
        }
      }
    }
  },
  computed: {
    valorTaxaOuDesconto() {
      return this.dadosProposicoesComerciais.desconto
        ? this.dadosProposicoesComerciais.desconto
        : this.dadosProposicoesComerciais.taxa;
    },
    disablePreposicaoComercial() {
      return (
        this.protocolo != null || this.dadosQuestionarioCompleto.id != null
      );
    },
    desabilitaConsideracao() {
      return ( this.disablePreposicaoComercial);
    },
    elementoPai: function() {
      return this.$parent.$parent.$parent;
    },
    tipoClienteComputed: function () {
      return TipoCliente;
    },
    textEdit() {
      if (this.dadosProposicoesComerciais.dataInicio) {
        return new Date(
          this.dadosProposicoesComerciais.dataInicio
        ).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      }
    },
    textInicio() {
      if (this.dadosProposicoesComerciais.vencimento) {
        return new Date(
          this.dadosProposicoesComerciais.vencimento
        ).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "long"
        });
      }
    },
    textEdit() {
      if (this.dadosProposicoesComerciais.dataInicio) {
        return new Date(
          this.dadosProposicoesComerciais.dataInicio
        ).toLocaleDateString("pt-BR", {
          timeZone: "UTC",
          year: "numeric",
          month: "long",
          day: "numeric"
        });
      }
    }
  },
  methods: {
    // Método para permitir apenas 3 casas decimais após a vírgula
    limitaCasasDecimaisDesconto($event) {
      if (
        this.dadosProposicoesComerciais.desconto != null &&
        this.dadosProposicoesComerciais.desconto.indexOf(".") > -1 &&
        this.dadosProposicoesComerciais.desconto.split(".")[1].length > 2
      ) {
        $event.preventDefault();
      }
    },
    limitaCasasDecimaisTaxa($event) {
      if (
        this.dadosProposicoesComerciais.taxa != null &&
        this.dadosProposicoesComerciais.taxa.indexOf(".") > -1 &&
        this.dadosProposicoesComerciais.taxa.split(".")[1].length > 2
      ) {
        $event.preventDefault();
      }
    },
    buscarTransportadora(val) {
      axios.get(`${process.env.URL_TRANSPORTADORAMS}/v1/buscaTransportadora?id=${val}`, {
        headers: {
          'Authorization': `Bearer ${usuarioHelper.USUARIO_LOGADO().token}`
        }
      }).then(res => {
        if(res.data) {
          if (res.data.tipoCliente.id == this.tipoClienteComputed.tipoCliente.TRANSPORTADOR) {
            this.ramoTransportador = true
          }
        }
      })
    },
    buscarTitulo(entity, list) {
      if (entity !== null && entity !== undefined) {
        const campo = list.find(
          item => item.id === entity || item.id === entity.id
        );
        if (campo) {
          return campo.titulo;
        }
      }
    },
    enviar() {
      this.proposicoesComerciais = false;
      this.$emit("dadosProposicoesComerciais", this.dadosProposicoesComerciais);
      this.elementoPai.enviaQuestionario();
    }
  }
};
</script>

<style>
.QuestionarioAnaliseRiscos .title-dialog-custom {
  color: #00456e;
  font-weight: bold;
  padding-bottom: 0;
  font-size: 18px;
}
.QuestionarioAnaliseRiscos .toolbar-custom {
  background-color: transparent;
}
.QuestionarioAnaliseRiscos .container-special {
  padding: 0 40px 40px 40px;
}

.QuestionarioAnaliseRiscos .telaProposições {
  margin-top: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/questionario-analise-riscos/steps/QARProposicoesComerciais.vue